import {Helpers} from '../helpers';

export const getCTOLink = (itemId, quantity=1, additionalParams, isV2) => {
	let basename = process.env.BASENAME || '/us/en'
	let params = {
        langId: -1,
        storeId: 10151,
        catalogId: 10051,
		catEntryId: itemId,
		urlLangId: "",
		quantity,
		...additionalParams
	};

	let paramsString = Helpers.paramsToString(params);
	//TODO: Temp code to support react CTO page
	const ctoLink = `${basename}/${isV2 ? 'configure/' : ''}ConfigureView?${paramsString}`
	//configure/ConfigureView
	return ctoLink;
}

class CTOAPI {
	constructor(apiConfig, http) {
		this.apiConfig = apiConfig;
		this.http = http;
	}

	addPreConfig(catEntryId) {
		return this.http.post("HPCTORestAddToCartCmd",Helpers.parseFormData({ catentryId: catEntryId}))
				.then(({ data }) => {
					//attemp to parse response
					if(data && data !== ''){
					    return JSON.parse(data.replace(/(\/\*|\*\/)/ig,''));
					}else{
						return Promise.reject('')
					}
				});
	}

}

export default CTOAPI;


